import { BsFacebook } from "react-icons/bs";
import { AiOutlineInstagram } from "react-icons/ai";
import { BsWhatsapp } from "react-icons/bs";
import { AiFillGithub } from "react-icons/ai";

const data = [
  { id: 1, link: "https://facebook.com", icon: <BsFacebook /> },
  { id: 2, link: "https://instagram.com", icon: <AiOutlineInstagram /> },
  { id: 3, link: "https://whatsapp.com", icon: <BsWhatsapp /> },
  { id: 4, link: "https://facebook.com", icon: <AiFillGithub /> },
];

export default data;
